{
  "0154a028a8dc3a3e": "Reglas y Expectativas",
  "049245ad1f768a37": "ID del lugar de trabajo",
  "082e2c29db933044": "Conectar EMR",
  "09a996ec24fb0a72": "Especialista en facturación",
  "09fd2948a8dffd21": "Lugar de trabajo",
  "0b9e49cf035bd75b": "Entrevistas",
  "0e199ed6d6f4b783": "Dotación de personal",
  "10104f72c61f60fd": "Tipos de lugares de trabajo",
  "11c4c9beeb1da7ae": "Verificación de Identidad",
  "12f67f8539c46701": "Disponibilidad",
  "15435b311c937143": "Ver más",
  "189d145aadfed8e7": "Por período",
  "18fdd549b2ed367a": "Nuevo",
  "19766ed6ccb2f4a3": "Cancelar",
  "216f411031cbef73": "Nombre del lugar de trabajo",
  "2249bd503ec47d72": "Casos",
  "26d6fb4222835ff1": "Necesitarás iniciar sesión nuevamente para acceder a tu cuenta.",
  "293be5f6b4a34190": "Violaciones de la Política de Insignias",
  "2bff98865447b479": "Soporte 24/7",
  "2d7e9dcd95624a2b": "¿Está seguro de que desea cerrar sesión en todos los dispositivos?",
  "30a2860742589675": "Mi lista interna",
  "324ddac12d893a7d": "Lugares de trabajo",
  "363d6a41a48b73a6": "Disputas después de la factura",
  "372330d1b42e8de2": "Explicación de turnos",
  "37ae24bdf1c25cd2": "Cuentas vistas recientemente",
  "38f01b3c5ffc13e3": "ID profesional",
  "3ac8bbca9a74cfbd": "Facturación",
  "3c653dabeef2e3c2": "Turnos",
  "3f9abc8733ba366a": "Menú de navegación",
  "3fa7a764f8ffaa77": "Agenda de entrevistas",
  "414aa5b4f7e46da8": "Reseñas de Badge-Strike",
  "460b3a7da007b7af": "Chat",
  "46bef04d5ef5c857": "Explora artículos de ayuda y encuentra respuestas a preguntas frecuentes.",
  "46d51ff0db7eb2e9": "Confirmar cierre de sesión",
  "47484938c8a87102": "Moderación de reseñas",
  "49c266baaaa70981": "Buscar",
  "4ab38aa0a0be3888": "Cambiar a administrador",
  "4b4a11d469f69455": "No hay lugares de trabajo disponibles",
  "4c4968ef0a179423": "Visita el Centro de Ayuda",
  "4d5469c7be3b5130": "Prohibiciones",
  "4df9939944a7b324": "Colocación",
  "4e414af41b7d4876": "Contratación",
  "4e952b41752d7990": "ETA de trabajador en vivo",
  "50ce48b9c623c1cd": "Abrir búsqueda",
  "53fe8dfb6d9e1b03": "Nómina",
  "55542efef9055f03": "Búsqueda de trabajador por SSN",
  "5a639e298037569b": "Puntuación de Clipboard",
  "5a79edda3e34d40e": "Cerrando sesión…",
  "5c7b8d053d5b3e26": "Registros de turnos",
  "5e39688b3981234f": "Videos de control de tiempo",
  "63256883cad9b1a5": "Análisis del lugar de trabajo",
  "65287dcca549e0db": "Contratación permanente",
  "6b653f745fa52b81": "Referir y ganar",
  "6ccd5c7856042d36": "Cerrar menú",
  "6e2ea637b30eadce": "No se encontraron registros",
  "6fd553132e7785dc": "Registro de cambios",
  "708e415f9ac11beb": "Mis profesionales",
  "736a8020568a3133": "Cada dispositivo que haya iniciado sesión en esta cuenta se cerrará de inmediato.",
  "74a883a037bc227f": "Configuraciones",
  "788011833a5a0f22": "Notificaciones",
  "79e57be0ede1ecb7": "No se pudo cerrar sesión en todos los dispositivos. Por favor, inténtalo de nuevo.",
  "7a1ec9fe6c3b483f": "Trabajadores",
  "7a21f9b68442b295": "Verificación de turnos",
  "7b4339cf860e01a6": "Calificaciones",
  "8216096dc5263713": "Cambiar de cuenta (actual: {{switcherTitle}})",
  "831d0f72d242b7d1": "Comenzando",
  "8378c006e5505ccf": "¿Estás seguro de que deseas cerrar sesión?",
  "83f74582a922da01": "Búsqueda de turnos",
  "84cb7871b741c32e": "Reseñas",
  "85279245c3c16c92": "Transferencias de Stripe",
  "881a371729ce67f0": "Configuraciones del reloj de tiempo",
  "8a7c8b67fe8bde8b": "Cuentas",
  "8adad8a24dbd0f7b": "Análisis corporativo",
  "8c13bf02a1a2b30e": "Evidencias del Trabajador",
  "8f74e5015dd26f64": "Historial de Facturas",
  "904b4af203bd9342": "Requisitos del Lugar de Trabajo",
  "92b899d39a9f6e5c": "Calificación de Verificación de Insignias",
  "9474c5cf93f62e30": "No Presentados",
  "94c116ee118a7299": "Analíticas",
  "95c61170318a2851": "Ubicaciones",
  "96d96be238230962": "Perfil del Candidato",
  "9839593ad1155065": "Actualmente Visto",
  "99f2b26bd7057b5b": "Nombre Profesional",
  "9a03073fb5cf415d": "Controles de Gastos",
  "9ca1816c47234807": "DNR",
  "a29be0c28e95f23f": "Cambiar lugar de trabajo",
  "a2e27badeaa364c4": "Cerrar sesión de todos los dispositivos",
  "a2fb237d15320535": "Cargos Pendientes",
  "a78cebc44214256b": "Centro de Ayuda",
  "a8959c978f05887f": "Buscar lugares de trabajo...",
  "a93cb7c71ee33577": "Página de Aterrizaje",
  "a9e0e7835ef824a7": "Acuerdos de Trabajo en Bulk",
  "abefee79c9ed4bb3": "Tocar para copiar",
  "ac549c250b476176": "En construcción",
  "ac9cde5b5bee03f3": "Mapa de Cobertura",
  "ad0187add790ff17": "Mi Cuenta",
  "af0c3ba6a2ca80ba": "Herramientas de Administración",
  "b1d3c3c3f44d8a16": "Información del Lugar de Trabajo",
  "b1fa104b9bf0635e": "Informes",
  "b40b3713b43dc702": "Abrir menú",
  "b4e929d8bcfe0418": "Documentos",
  "b79cac926e0b2e34": "Ayuda",
  "b832002da297545f": "Factura",
  "bcc957ee4ec02126": "Por Número",
  "be5acd2ec9bc6849": "Términos del Contrato",
  "c0ebbcb9d9b6e9d3": "Desplázate a los elementos pendientes a continuación",
  "c2c3b55d9c20c18a": "Disponibilidad para Entrevistas",
  "c5487af5ec0de077": "Buscar agentes o lugares de trabajo",
  "c7677b97318f448a": "Portal de SMS",
  "c897635c22a67087": "Verificación de Visitas",
  "c8d715a6f56bac25": "Profesionales",
  "c9271e487280e152": "No hay lugares de trabajo que coincidan con \"{{searchTerm}}\"",
  "c98270317b51cbb3": "Empleados",
  "ccc498b77ae62cf8": "Gerente de cuentas",
  "cdf7ce7d44347fa1": "Otros lugares de trabajo",
  "cf38d8fe149ecdf8": "Raspado",
  "d065e5b97c6f5a6b": "Cargar más lugares de trabajo",
  "d0ed4b43b56d7470": "Seleccionar cuenta",
  "d159134ea385fdbc": "Aplicaciones y Empleos",
  "d57d48b71020b33a": "Cerrar Sesión",
  "d5d0a30b517e3bea": "Calendario",
  "d9e7915f59343c9b": "Buscar Profesionales",
  "daeb3a9c6c097148": "Centro Corporativo",
  "db87f5ee3afa1ca9": "Pagos de Stripe",
  "dfa9dfa5cad2d8f9": "Elegibilidad",
  "e0cdd07f6a270b82": "Requisitos",
  "e0d1b68224bf0b31": "Actual",
  "e2204b3eaff613de": "Miembros del Equipo",
  "e3373cf04f80ef64": "Disputas de Pre-Factura",
  "e3c8c9b2fc87dc21": "Cuestionario de Reglas del Lugar de Trabajo",
  "e51248773b9a3f59": "Administración",
  "e7d3e769f3f593da": "Administrador",
  "ea61bc15688d1e48": "¡Copiado!",
  "eab19ec694a80bca": "Vistos Recientemente",
  "ec7ee2826c849564": "Copiar detalles",
  "edad27774d43f2d1": "Calendario (Clásico)",
  "ee1b6e3886b4d185": "Fotos Externas",
  "f2b4bd6f9b506e10": "Solicitudes de Registro de Tiempo",
  "f4830a1dae298044": "Horario",
  "f4d573798f5b25fe": "Gráficas",
  "f5b152d912d4a37a": "Explorar el grupo de talento",
  "f5dc11ce70f8dd27": "Desplázate a los elementos pendientes arriba",
  "f6120e8981f1882f": "DNRs",
  "f8d47b82e285ba95": "Contactar a soporte",
  "fa00fd7d75c43f54": "Pagos de turno",
  "fcc9f1f929785440": "Exclusiones",
  "fe01dd4acbf69e7c": "Actualmente estamos realizando mejoras a nuestra aplicación móvil. ¡Cuando esté lista, te lo haremos saber!",
  "ff9c41ba1c875fb1": "Búsqueda de trabajadores de salud en el hogar"
}
